<template>
	<router-view></router-view>
</template>

<script>
export default {
	watch: {
		$route(to) {
			this.$gtag.query('config', process.env.VUE_APP_UA, {'page_path': to});
		}
	},
	created() {
		const path = this.$route.path
		this.$gtag.query('config', process.env.VUE_APP_UA, {'page_path': path});
	}
}
</script>
